module.exports = __webpack_public_path__ + "img/927.e908e551.jpg";